module.exports = __webpack_public_path__ + "index-bg123.jpg?9313efc7ccbfe1b3e5f9164daa7a0da0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-bg123.jpg
// module id = 40
// module chunks = 0